import { apiGet } from '@api/api.utils'
import { IResponsePaymentNotificationsList } from './api.types'


const route = '/paymentNotifications'

/** Основной список извещений о платежах */
export const getPaymentNotificationsList = (pageNumber: number, search?: string, signal?: AbortSignal): Promise<IResponsePaymentNotificationsList> =>
    apiGet<IResponsePaymentNotificationsList>(`${route}/getPaymentNotificationsList`, { params: { pageNumber, search }, signal })